export default "__VITE_ASSET__yP1cRTSk__"